<ng-content select="[prepend]" />
@for (item of nav()?.items ?? []; track item?.id ?? item) {
  @if (item.isPanelInDom()) {
    @let itemLoading = item.isLoading();

    <div
      class="mbs-tab-pane"
      [class.active]="item.isActive"
      [class.d-none]="!item.isActive"
      [class.h-100]="item.fullHeight"
      [class.loading]="itemLoading || item.isForceLoading">
      @if (itemLoading || item.isForceLoading) {
        <mbs-loader />
      }
      <div
        [class.h-100]="item.fullHeight"
        [hidden]="itemLoading || item.isForceLoading">
        <ng-template
          [ngTemplateOutlet]="item.contentTemplate?.templateRef"
          [ngTemplateOutletContext]="{ $implicit: item?.isActive }" />
      </div>
    </div>
  }
}
<ng-content select="[append]" />
